import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=3e30049e&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"
import style0 from "./RoleView.vue?vue&type=style&index=0&id=3e30049e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e30049e",
  null
  
)

export default component.exports